import {useEffect} from "react";
import {I18nProvider} from "@lingui/react";
import App from "@/App.tsx";

import {i18n} from "@lingui/core";
import {dynamicActivate} from "@/i18nConfig.ts";


const I18nApp = () => {
    useEffect(() => {
        // With this method we dynamically load the catalogs
        dynamicActivate('en');
    }, []);

    return (
        <I18nProvider i18n={i18n}>
            <App />
        </I18nProvider>
    );
};
export default I18nApp